import { useEffect, useState } from "react";
import API from "../api/api";

const when = (value) => (value ? new Date(value).toLocaleString("en-IN", { day: "2-digit", month: "short", year: "numeric", hour: "2-digit", minute: "2-digit" }) : "Never");
const WHATSAPP_LABELS = { connected: "Connected", not_connected: "Not connected", error: "Error", not_checked: "Not checked" };
const TITLES = { whatsapp: "WhatsApp connection", email: "Email settings", webhooks: "Webhooks" };

function Row({ label, children }) {
  return <p className="table-secondary" style={{ margin: "4px 0" }}><strong>{label}:</strong> {children}</p>;
}

function Status({ family, data }) {
  if (family === "whatsapp") {
    const { whatsapp } = data;
    return (
      <>
        <Row label="Status"><span className="status-pill">{WHATSAPP_LABELS[whatsapp.status] || whatsapp.status}</span></Row>
        <Row label="Last verified">{when(whatsapp.lastVerifiedAt)}</Row>
        {whatsapp.lastError && <Row label="Last error">{whatsapp.lastError}</Row>}
      </>
    );
  }
  if (family === "email") {
    return (
      <>
        <h3 style={{ margin: "12px 0 4px" }}>Email accounts</h3>
        {data.email.length === 0 && <p className="table-secondary">No email account is set up.</p>}
        {data.email.map((account, index) => (
          <Row key={account.id} label={`Account ${index + 1}`}>
            <span className="status-pill">{account.status === "connected" ? "Connected" : "Disconnected"}</span> {account.enabled ? "On" : "Off"} · last tested {when(account.lastTestedAt)}{account.hasError ? " · last test failed" : ""}
          </Row>
        ))}
        <h3 style={{ margin: "12px 0 4px" }}>Capture rules</h3>
        {data.captureRules.length === 0 && <p className="table-secondary">No capture rule is set up.</p>}
        {data.captureRules.map((rule) => <Row key={rule.id} label={`${rule.name} (${rule.platform})`}>{rule.enabled ? "On" : "Off"}</Row>)}
      </>
    );
  }
  return (
    <>
      {data.webhooks.length === 0 && <p className="table-secondary">No webhook is set up.</p>}
      {data.webhooks.map((hook) => (
        <Row key={hook.id} label={hook.name}>
          <span className="status-pill">{hook.active ? "Active" : "Paused"}</span> · last delivered {when(hook.lastSuccessAt)}{hook.lastFailureAt ? ` · last failure ${when(hook.lastFailureAt)}` : ""}
        </Row>
      ))}
    </>
  );
}

// The settings pages the platform account manages for a vendor. While the lock is on the vendor sees only their status here; while it is off the
// page itself opens, as it always has. The server refuses a vendor's changes either way - this only decides what is shown.
export default function ManagedSettingsGate({ family, children }) {
  const [state, setState] = useState({ loading: true, data: null });

  useEffect(() => {
    let active = true;
    API.get("/admin/managed-settings", { suppressGlobalError: true, cache: false })
      .then((response) => { if (active) setState({ loading: false, data: response.data }); })
      .catch(() => { if (active) setState({ loading: false, data: null }); });
    return () => { active = false; };
  }, []);

  if (state.loading) return <section className="panel"><p className="empty-state">Loading...</p></section>;
  if (!state.data?.locked) return children;
  return (
    <section className="panel" aria-label={TITLES[family]}>
      <h2 style={{ marginTop: 0 }}>{TITLES[family]}</h2>
      <p className="table-secondary">These settings are managed by the platform administrator. You can see their status here; to change anything, ask them.</p>
      <Status family={family} data={state.data} />
    </section>
  );
}
